module.exports = __webpack_public_path__ + "static/media/vip-game-play.df4c3d44.svg";